import { SideNav } from './SideNav';
import { SideNavHeader } from './SideNavHeader';
import { SideNavLink } from './SideNavLink';

SideNav.Header = SideNavHeader;
SideNav.Link = SideNavLink;

export { SideNav };
